export default __webpack_public_path__ + "static/media/SDG17.e74f5b13.png";